import '../../utils/index.mjs';
import Segmented from './src/segmented2.mjs';
export { segmentedEmits, segmentedProps } from './src/segmented.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElSegmented = withInstall(Segmented);

export { ElSegmented, ElSegmented as default };
//# sourceMappingURL=index.mjs.map
